import { useMemo } from "react";
import { isMsalCookiePresent } from "../auth/msal-cookie-extractor";

enum Environment {
  Browser,
  MobileApp,
}

export const useEnvironment = (): Environment => {
  return useMemo(() => {
    if (isMsalCookiePresent()) {
      return Environment.MobileApp;
    }
    return Environment.Browser;
  }, []);
};

export const isRunningInMobileApp = (e: Environment) =>
  e === Environment.MobileApp;
export const isRunningInBrowser = (e: Environment) => e === Environment.Browser;
